import { Button, Modal } from 'antd';

type IncidenceRequestSubmitConfirmModalProps = {
  open: boolean;
  mobileOnly: boolean;
  onClose: () => void;
  onConfirm: () => void;
};

export const IncidenceRequestSubmitConfirmModal = ({
  open,
  mobileOnly,
  onClose,
  onConfirm,
}: IncidenceRequestSubmitConfirmModalProps) => {
  return (
    <Modal
      open={open}
      title="Enviar solicitud"
      onCancel={onClose}
      footer={null}
      destroyOnHidden
      maskClosable={false}
      centered
      width={mobileOnly ? 'calc(100% - 40px)' : 510}
      className="incidence-request-submit-modal"
      getContainer={false}
      data-cy="incidence-request-submit-modal"
    >
      <p className="incidence-request-submit-modal-description">
        Al enviar esta solicitud de incidencia, será notificado tu supervisor o
        área correspondiente y no podrás editarla. ¿Deseas enviarla ahora?
      </p>

      <div className="incidence-request-submit-modal-footer">
        <Button
          className="incidence-request-submit-modal-btn incidence-request-submit-modal-btn-secondary"
          onClick={onClose}
          data-cy="incidence-request-submit-review-btn"
        >
          Revisar nuevamente
        </Button>
        <Button
          type="primary"
          className="incidence-request-submit-modal-btn"
          onClick={onConfirm}
          data-cy="incidence-request-submit-confirm-btn"
        >
          Enviar
        </Button>
      </div>
    </Modal>
  );
};
